require('./bootstrap');

window.Vue = require('vue');

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
// Vue.component('tour-filters', require('./components/TourFilters.vue').default);

import pt from './vee-validate/pt_PT';
import de from 'vee-validate/dist/locale/de';
import fr from 'vee-validate/dist/locale/fr';
import es from 'vee-validate/dist/locale/es';
import cn from 'vee-validate/dist/locale/zh_CN';
import VeeValidate, { Validator } from 'vee-validate';
import PhoneNumber from 'awesome-phonenumber'

import VueNumberInput from '@chenfengyuan/vue-number-input';
import VTooltip from 'v-tooltip'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-41523831-1'
})
Vue.use(VueNumberInput);
Vue.use(VeeValidate);
Vue.use(VTooltip);


const phoneNumber = {
    // getMessage: field => `${field} is not a valid phone number`,
    validate (value) {
      return new Promise(resolve => {
        let phone = new PhoneNumber(value);
        resolve({ valid: phone.isValid() })
      })
    }
  }
Validator.extend('phoneNumber', phoneNumber)

Vue.filter('reverse', function (value) {
    return value.split('').reverse().join('')
})

import initLogin from './login';
import initSearch from './search';
var element =  document.getElementById('app');
if (typeof(element) != 'undefined' && element != null)
{
    const app = new Vue({
        el: '#app',
    });
}


initLogin();
initSearch();

import 'lightgallery';
import 'lg-thumbnail';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import 'slick-carousel';
var Cookies = require('js-cookie');



$( document ).ready(function() {

    $(".footer__col--menu a, .footer__col--menu-mobile a").click( function (e) {
        var href = $(this).attr('href');
        if(href == "#login") {
            e.preventDefault();
            window.scrollBy(0, -10);
            $('.header__loginbtn').addClass('active');
            $('.header').addClass('helper_open');
            $('#login_menu').fadeIn('fast');
        }
    });
    
    swtichValidatorLang();

    $('.s_slider').slick({
        dots: false,
        arrows: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        nextArrow: '<button class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="12.417" height="20.741" viewBox="0 0 12.417 20.741"><path id="Path_34632" data-name="Path 34632" d="M-5756.666-3624.51l-9.309,9.253-9.332-9.02" transform="translate(3625.574 -5755.608) rotate(-90)" fill="none" stroke="#95aab9" stroke-width="3"/></svg></button>',
        prevArrow: '<button class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="12.417" height="20.74" viewBox="0 0 12.417 20.74"><path id="Path_34631" data-name="Path 34631" d="M-5756.666-3624.51l-9.309,9.253-9.332-9.02" transform="translate(-3613.156 5776.349) rotate(90)" fill="none" stroke="#95aab9" stroke-width="3"/></svg></button>',
        responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '30px',
                slidesToShow: 1
              }
            },
        ]
    });

    $('.tailormade__header__howitworks__carousel').slick({
        infinite: false,
        dots: false,
        arrows: false,
        slidesToShow: 3,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                infinite: false,
                variableWidth: false,
                dots: true,
                autoplay: true,
                autoplaySpeed: 2100,
              }
            },
        ]
    });
    $('.tailormade__header__howitworks__carousel').fadeIn();

    $(window).resize(function(){
        if( $('.tailormade__header__howitworks__carousel').length) {
            $('.tailormade__header__howitworks__carousel')[0].slick.refresh();
        }
      });

    $('.reviews__carousel__inner').slick({
        infinite: true,
        dots: true,
        arrows: false,
        speed: 500
    });

    $("#lightgallery").lightGallery({
        thumbnail:true,
        download: false,
        subHtmlSelectorRelative: true
    }); 
    $('.tour__tabs__gallery').on('click', function(e) {
        e.preventDefault()
        $('#lightgallery a:first-child').trigger('click');
     });

    $('.scrollto').click(function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        $("html, body").animate({ scrollTop: $(href).offset().top - 70 }, 500);
    });

     $('.header__helpers a').click(function(e) {
        if($(this).hasClass('header__logo__mobile')) {
            return;
        }
        e.preventDefault();
        if($(this).hasClass('active')) {
            $('.header__helpers a').removeClass('active');
            $('.header').removeClass('helper_open');
            return;
        }
        $('.header__helpers a').removeClass('active');
        $(this).addClass('active');
        var type = $(this).data('type');
        $('.header').addClass('helper_open');
        $('.header__menu__sub__item').fadeOut('fast').promise().done(function() {
            $('#'+type).fadeIn('fast');
        });
        
     });

    $('.burger').click(function(){
        $(this).toggleClass('open');
        $('.header').toggleClass('open');
    });
    $('.blog__sidebar__section--categories h3').click(function(){
        $(this).parent().toggleClass('open');
    });


    $('.dropdown-list__item__display').click(function(){
        // $(this).closest('.dropdown-list__item').find('.dropdown-list__item__drop').toggleClass('show');
        // $('.dropdown-list__item__drop').slideUp();
        // $(this).next('div').toggleClass('show').slideToggle();
        $(this).toggleClass('open').next('div').slideToggle();    
        $(this).parent().siblings().children().removeClass('open').next().slideUp();
    });

    blogPagination();

    if ($(window).width() < 769) {
        $('.tours__filters__card__upper').click(function() {
            // $('.tours__filters__card__lower').not(this).slideUp();
            // $(this).toggleClass('open').parent().find('.tours__filters__card__lower').slideToggle();
            $(this).toggleClass('open').next('div').slideToggle();
            
            $(this).parent().siblings().children().removeClass('open').next().slideUp();
            return false;
        });
    }
    $('.toggle_filters--close').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('.tours__filters__card__lower').slideToggle();
    });

    $('.book_now_mobile a').click(function(e){
        e.preventDefault();
        $('.tour__reservation').addClass('open');
        $('body').addClass('reservation_open');
        $(this).parent().addClass('hide');
    });
    $('.tour__reservation__close').click(function(e){
        e.preventDefault()
        $(this).parent().parent().removeClass('open');
        $('body').removeClass('reservation_open');
        $('.book_now_mobile').removeClass('hide');
    });

    $('.modal__close').click(function(e) {
        e.preventDefault();
        var targetElement = document.querySelector('.modal');
        $('.modal').fadeOut();
        enableBodyScroll(targetElement);
        $('body').css({'overflow': 'auto'});
    });

    init_tour_tabs();
    init_tabs();
    initMenuFixed();
    initMemberModal();
    initBecomeInsiderModal();
    initGroupInquiryModal();
    initHomeCarousel();
    initInsderMonthCarousel();
    initInstagramCarousel();
    initHeaderScroll();
    initDragScroll();
    hideCarouselTitle();
    initCookies();
    if($('.about .tabs__nav').length) initTabMenuScroll();
    if($('.press_filters').length) initPressTabs();

});
$.fn.attachDragger = function(){
    var attachment = false, lastPosition, position, difference;
    $(this).on("mousedown mouseup mousemove",function(e){
        e.stopImmediatePropagation();
        if( e.type == "mousedown" ) attachment = true, lastPosition = [e.clientX, e.clientY];
        if( e.type == "mouseup" ) attachment = false;
        if( e.type == "mousemove" && attachment == true ){
            $(this).addClass('dragging');
            position = [e.clientX, e.clientY];
            difference = [ (position[0]-lastPosition[0]), (position[1]-lastPosition[1]) ];
            $(this).scrollLeft( $(this).scrollLeft() - difference[0] );
            $(this).scrollTop( $(this).scrollTop() - difference[1] );
            lastPosition = [e.clientX, e.clientY];
        }
        if(!attachment) {
            setTimeout(() => {
                $(this).removeClass('dragging')
            }, 200);
        }
    });
    $(window).on("mouseup", function(){
        attachment = false;
        setTimeout(() => {
            $(this).removeClass('dragging')
        }, 200);
    });
}

function initPressTabs() {
    $('.press_filters a').click(function(e) {
        e.preventDefault();
        if($(this).hasClass('active')) return;
        let filter = $(this).data('filter');
        if(filter=="all") {
            $('.dropdown-list li').fadeIn(300);
            return;
        }
        $('.dropdown-list li').fadeOut(300).promise().done(function() {
            $('.dropdown-list li[data-category="'+filter+'"]').fadeIn(300);
        });
    }); 
}

function initTabMenuScroll() {
    var lastId,
    topMenu = $(".tabs__nav"),
    topMenuHeight = topMenu.outerHeight()+135,
    // All list items
    menuItems = topMenu.find("a"),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function(){
      var item = $($(this).attr("href"));
      if (item.length) { return item; }
    });

    $(window).scroll(function(){
    var fromTop = $(this).scrollTop()+topMenuHeight;
    
    var cur = scrollItems.map(function(){
        if ($(this).offset().top < fromTop)
        return this;
    });
    cur = cur[cur.length-1];
    var id = cur && cur.length ? cur[0].id : "";
    
    if (lastId !== id) {
        lastId = id;
        menuItems
            .removeClass("active")
            .filter("[href='#"+id+"']").addClass("active");
            movenavline();
    }                   
    });
}

function hideCarouselTitle() {
    if($('.home__carousel__inner__titles').length> 0) {
        var $win = $(window);
        var winH = $win.height();
        var $titles = $('.home__carousel__inner__titles');

        $win.on("scroll", function () {
            if ($(this).scrollTop() > winH/1.5 ) {
                $titles.addClass("hide");
            } else {
                $titles.removeClass("hide");
            }
        }).on("resize", function(){
           winH = $(this).height();
        });
    }
}
function initDragScroll() {
    $('.home__cards-slider__cat__inner').each(function( index ) {
        $(this).attachDragger();
    });
    $('body').on('click', '.dragging a', function(e) {
        e.preventDefault();
    });
}


document.addEventListener('sticky-change', e => {
    const header = e.detail.target;  // header became sticky or stopped sticking.
    const sticking = e.detail.stuck; // true when header is sticky.
    header.classList.toggle('shadow', sticking); // add drop shadow when sticking.
    document.querySelector('.who-is-sticking').textContent = header.textContent;
  });

function initHeaderScroll() {
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('header').outerHeight();

    $(window).scroll(function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(document).scrollTop();
        
        if(Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight){
            $('header').removeClass('nav-down').addClass('nav-up');
        } else {
            if(st + $(window).height() < $(document).height()) {
                $('header').removeClass('nav-up').addClass('nav-down');
            }
        }
        lastScrollTop = st;
    }
}

function initBecomeInsiderModal() {
    $(".team__members__become a").click(function(e) {
        e.preventDefault();
        $('.become_insider').fadeIn();
        var targetElement = document.querySelector('.modal');
        disableBodyScroll(targetElement);

    });
}

function initGroupInquiryModal() {
    $(".send_iquiry").click(function(e) {
        e.preventDefault();
        $('.group_inquiry').fadeIn();
        var targetElement = document.querySelector('.modal');
        disableBodyScroll(targetElement);

    });
}

function initMemberModal() {
    $(".team-member").on("click", ".modal__close", function(){
        if($(this).parent().parent().hasClass('team-member--single')) { 
            window.location = '/reviews'
        }
        $(this).parent().parent().fadeOut();
        var targetElement = document.querySelector('.modal');
        $('body').css({'overflow': 'auto'});
        enableBodyScroll(targetElement);
    });
    $('a.team__members__member__open').click(function(e) {
        e.preventDefault();
        var member_id = $(this).data('member_id');
        getMember(member_id);
        
    });
    $(".team-member").on("click", ".team-member__links a", function(e){
        e.preventDefault();
        var member_id = $(this).data('member_id');
        getMember(member_id);

    });
    function getMember(member_id) {
        let data = {
            'member_id' : member_id,
            'language' : document.documentElement.lang
        }
        axios.post('/team-member', data, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then( response => {
            console.log(response);
            $('.modal.team-member').html(response.data);
            var targetElement = document.querySelector('.modal');
            disableBodyScroll(targetElement);
            $('.modal.team-member').fadeIn();
            
        })  
        .catch( e => { 

        });
    }
}

function initMenuFixed() {
    $(document).scroll(function() {

        if ( $(document).scrollTop() >= 50 ) {
            $('.header').addClass('fixed');
            if($('.espa_banner').length) $('.espa_banner').addClass('hide');
        }  else {
            $('.header').removeClass('fixed');
            if($('.espa_banner').length) $('.espa_banner').removeClass('hide');
        }
    });
}
function init_tabs() {
    var $line = $('.nav_line');
    if(!$line.length) return
    movenavline();

    $('.tabs__nav li').click(function(e) {
        if($('a', this).hasClass('btn')) return;
        e.preventDefault();
        $('.tabs__nav a').removeClass('active');
        $(this).find('a').addClass('active');
        movenavline();

        var index = $(this).index();
        $('.tabs__content__item').fadeOut('fast').promise().done(function() {
            $(".tabs__content .tabs__content__item:eq("+parseInt(index)+")").fadeIn('fast');
        });
    });

    
}
function movenavline() {
    if(!$('.nav_line').parent().find('li').length) return;
    $('.nav_line').delay(300).fadeIn();
    var active_position= $('.tabs__nav a.active').position();
    var active_width = $('.tabs__nav a.active').width();
    $('.nav_line').css({'left': active_position.left - 15 + (active_width/2) + 'px' });
}
function init_tour_tabs() {
    var $line = $('.link_line');
    if(!$line.length) return
    moveline();

    $('.tour__tabs li').click(function(e) {
        if($(this).is(':first-child')) return;
        e.preventDefault();
        $('.tour__tabs a').removeClass('active');
        $(this).find('a').addClass('active');
        moveline();

        var index = $(this).index();
        $('.tour__tabs__item').fadeOut('fast').promise().done(function() {
            $(".tour__tabs__content .tour__tabs__item:eq("+parseInt(index - 1)+")").fadeIn('fast');
        });
    });

    function moveline() {
        $('.link_line').delay(300).fadeIn();
        var active_position= $('.tour__tabs a.active').position();
        var active_width = $('.tour__tabs a.active').width();
        $('.link_line').css({'left': active_position.left - 15 + (active_width/2) + 'px' });
    }
}

function blogPagination() {
    var blog_pagination = 1;
    var lang = "";
    if(document.documentElement.lang != "en") {
        lang = '/'+document.documentElement.lang;
    }
    $('.load_more').click(function() {
        var $this = $(this);
        $this.prop('disabled', true);
        blog_pagination++;
        $.ajax({
            type: 'GET',
            url : lang + '/blog?page=' + blog_pagination,
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                $('.blog__w_sidebar .blog__cont').append(data.view);
                $this.prop('disabled', false);
                if(blog_pagination >= data.last_page) {
                    $this.fadeOut();
                }
            },
            error: function() {
                console.log('error');
            }
        });
    });
}

function initInsderMonthCarousel() {
    if(!$('.insider-month__review__carousel').length) return;

    $('.insider-month__review__carousel').slick({
        infinite: true,
        dots: true,
        arrows: false,
        speed: 500
    });

}

function initHomeCarousel() {
    if(!$('.home__carousel__inner').length) return;

    $('.home__carousel__control__inner li a').click(function(e) {
        e.preventDefault();
        var order = $(this).parent().index();
        // $('.home__carousel__inner__titles h3').fadeOut(700).promise().done(function() {
        //     $(".home__carousel__inner__titles h3:eq("+order+")").fadeIn(700);
        // });
        $('.home__carousel__inner__titles h3.active').removeClass('active');
        $(".home__carousel__inner__titles h3:eq("+order+")").addClass('active');
        // $('.home__carousel__inner__titles h3.active').stop().fadeOut(700).promise().done(function() {
        //     $(this).removeClass('active')
        //     $(".home__carousel__inner__titles h3:eq("+order+")").stop().fadeIn(700).addClass('active');
        // });
        // $('.home__carousel__inner__titles h3').stop().fadeOut(700, function() {
        //     $(".home__carousel__inner__titles h3:eq("+order+")").stop().fadeIn(700);
        // });
        
        $('.home__carousel__item').removeClass('active');
        var $slide = $(".home__carousel__inner .home__carousel__item:eq("+order+")");
        $slide.addClass("active");
        var window_width= $(window).width();
        var scrollbar_width_fix = 0;
        $('.home__carousel__inner').stop().animate({scrollLeft: window_width*order + scrollbar_width_fix}, {duration: 1400,easing: 'easeInOutQuart'});
    });

    $(".home__carousel__inner").scroll(function() { 
        moveElementsSlider(parseInt($(".home__carousel__inner").scrollLeft()));
    });

    $('.home__carousel__control a').click(function() {
        var id = $(this).attr('href');
        $('.home__cards-slider__cat').fadeOut('fast').promise().done(function() {
            $(id).fadeIn('fast');
        });
    });
}
function moveElementsSlider(scroll) {
    $( ".home__carousel__item" ).each(function( index ) { 
        var left = parseInt($(this).position().left);
        var window_width= $(window).width();
        var movement = left + index * window_width - scroll;
        $('.layer2',this).css({'transform': 'translateX('+movement+'px)'});
        $('.home__carousel__inner h3').css({'transform': 'translateX('+scroll*-0.01+'px)'});
        $('.home__carousel__clouds').css({'transform': 'translateX('+scroll*-0.08+'px)'});
    });
}

function initInstagramCarousel() {
    $('.home__content__instagram__slider').slick({
        centerMode: true,
        centerPadding: '120px',
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '80px',
              slidesToShow: 3
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 1
            }
          }
        ]
      });
}



//detect sticky change
var _$stickies = [].slice.call(document.querySelectorAll('.sticky'));

_$stickies.forEach(function(_$sticky){
    if (CSS.supports && CSS.supports('position', 'sticky')) {
        apply_sticky_class(_$sticky);

        window.addEventListener('scroll', function(){
            apply_sticky_class(_$sticky);
        })
    }
})

function apply_sticky_class(_$sticky){
    var currentOffset = _$sticky.getBoundingClientRect().top;
    var stickyOffset = parseInt( getComputedStyle(_$sticky).top.replace('px','') );
    var isStuck = currentOffset <= stickyOffset;

    if (isStuck) {
        _$sticky.classList.add('is-sticky');
    } else {
        _$sticky.classList.remove('is-sticky');
    }
}

function initCookies() {
    var cookies_accept = Cookies.get('accept_cookies');
    if(!cookies_accept) {
        $('.cookie_law').fadeIn();
    }

    $('.cookie_law button').click(function(e) {
        e.preventDefault();
        Cookies.set('accept_cookies', 'accepted', { expires: 365 });
        $('.cookie_law').fadeOut();
    });
}


function swtichValidatorLang() {
    var lang = document.documentElement.lang;
    if(lang == 'de') {
        Validator.localize('de',de);
    } else if( lang == "pt" ) {
        Validator.localize('pt',pt);
    } else if( lang == "es" ) {
        Validator.localize('es',es);
    } else if( lang == "cn" ) {
        Validator.localize('cn',cn);
    } else if( lang == "fr" ) {
        Validator.localize('fr',fr);
    }
}

function check_webp_feature(feature, callback) {
    var kTestImages = {
        lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
        animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
    };
    var img = new Image();
    img.onload = function () {
        var result = (img.width > 0) && (img.height > 0);
        callback(feature, result);
    };
    img.onerror = function () {
        callback(feature, false);
    };
    img.src = "data:image/webp;base64," + kTestImages[feature];
}

check_webp_feature('lossy', function (feature, isSupported) {
    if (isSupported) {
        $('body').addClass('webp')
    }
});